module.exports = "/static/images/texture-forest-2.webp";